import classNames from 'classnames'
import PropTypes from 'prop-types'

import Checkbox from './Checkbox'
import styles from './styles/CheckRow.css'

export function CheckRow ({ className, checked, toggle, children, disabled, reversed = false, name, value, ...rest }) {
  return (
    <label
      className={classNames(styles.checkRow, className, {
        [styles.disabled]: disabled
      })}
    >
      {!reversed && <Checkbox checked={checked} onChange={toggle} disabled={disabled} name={name} value={value} {...rest} />}
      <span className={styles.checkRowLabel}>
        {children}
      </span>
      {reversed && <Checkbox checked={checked} onChange={toggle} disabled={disabled} name={name} value={value} {...rest} />}
    </label>
  )
}

CheckRow.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  toggle: PropTypes.func,
  className: PropTypes.string
}

export default CheckRow
